import { getBuildDate, getVersion } from 'config/env';
import { maybeSetupSentry } from 'config/sentry';
import Root from 'modules/root/Root';
import React from 'react';
import { render } from 'react-dom';
import startRoutines from 'streams/startRoutines';
import startStateRoutines from 'streams/startStateRoutines';
import startStateStreams from 'streams/startStateStreams';

console.log(
  `[TB Sail] ${getVersion()}${getBuildDate() ? ` · built ${getBuildDate()}` : ''}`,
);

maybeSetupSentry();
startStateStreams();
startRoutines();
startStateRoutines();

const renderAppContainer = () => {
  render(<Root />, document.getElementById('app'));
};

renderAppContainer();
